<template>
  <div id="home">
    <div>
      <div>
        <h2Title title="人事待处理"></h2Title>
        <div class="left-top">
          <div
            class="item"
            v-for="todo in todoLists"
            :key="todo.id"
            @click="linkPage(todo.url)"
          >
            <span>{{ todo.data }}</span>
            <p :class="anniversary?'f16':''">{{ todo.name }}</p>
          </div>
        </div>
      </div>
      <div>
        <h2Title title="工作日历" style="margin-top: 10px"></h2Title>
        <calendar :showMask.sync="showMask"> </calendar>
      </div>
    </div>
    <div>
      <div class="leftCon">
        <h2Title title="人事概况"></h2Title>
        <charts></charts>

        <quickAccess :showMask.sync="showMask"></quickAccess>
        <h2Title title="资讯" style="margin-top: 10px">
          <el-link type="info" class="shortMenu" @click="more()">
            查看更多</el-link
          >
        </h2Title>
        <informationList></informationList>
        <div class="img">
          <img
            src="@/assets/img/main/bg1.png"
            @click="openPage()"
            style="width: 100%"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="Mask" v-if="showMask"></div>
  </div>
</template>

<script>
import {
  queryPendingList,
  queryPendingNum,
  queryOperManual,
} from "@/api/msg/msg";
import {
  getAnniversaryCount ,
} from "@/api/wage/ysqh";
import h2Title from "@/page/statistics/template/title.vue";
import charts from "@/page/statistics/template/charts.vue";
import quickAccess from "@/page/statistics/template/quick-access.vue";
import informationList from "@/page/statistics/template/information-list.vue";
import calendar from "@/page/statistics/template/calendar.vue";
import {mapGetters} from 'vuex';
export default {
  name: "index",
  computed: {
  ...mapGetters(['userInfo']),
  },
  data() {
    return {
      todoLists: [],
      showMask: false,
      anniversary:false,
    };
  },
  created() {
    var ruZhi = JSON.parse(sessionStorage.getItem("ruZhi"));
    var yuanGong = JSON.parse(sessionStorage.getItem("yuanGong"));
    var heTong = JSON.parse(sessionStorage.getItem("heTong"));
    var xinZi = JSON.parse(sessionStorage.getItem("xinZi"));
    queryPendingList().then((res) => {
      let todoLists = res.data.data;
      if (this.userInfo.cusId == "9999011234" || this.userInfo.cusId == "9999007182") {
		  this.anniversary = true
        //原生启恒显示纪念日提醒
        getAnniversaryCount({
          param:JSON.stringify({
            cusId:this.userInfo.cusId
          })
        }).then(res=>{
        	todoLists.push(
            {
              data: res.data.data.oneanni,
              name: "一周年提醒",
              url: "/wage/anniversary",
            },
            {
              data: res.data.data.threeanni,
              name: "三周年提醒",
              url: "/wage/anniversary",
            },
            {
              data: res.data.data.fiveanni,
              name: "五周年提醒",
              url: "/wage/anniversary",
            }
          );
        })
      }
       if (todoLists != null && todoLists.length > 0) {
          for (let i = 0; i < todoLists.length; i++) {
            todoLists[i].data = 0;
          }
        }
        if (ruZhi != "入职管理") {
          todoLists[0].url = "#";
        }
        if (yuanGong != "员工管理") {
          todoLists[1].url = "#";
        }
        if (heTong != "合同管理") {
          todoLists[2].url = "#";
        }
        if (yuanGong != "员工管理") {
          todoLists[3].url = "#";
        }
        if (xinZi != "薪资待完成") {
          todoLists[4].url = "#";
        }
        this.todoLists = todoLists;
        //遍历请求数量
        for (let i = 0; i < this.todoLists.length; i++) {
          this.queryPendingNum(i); //加载数量
        }
    });
  },
  components: {
    h2Title,
    charts,
    quickAccess,
    informationList,
    calendar,
  },
  methods: {
    //加载待办数量
    queryPendingNum(i) {
      queryPendingNum(this.todoLists[i].funcSign).then((res) => {
        this.todoLists[i].data = res.data.data;
      });
    },
    linkPage(url) {
      this.$router.push({ path: url });
    },
    more() {
      this.$router.push({ path: "/information" });
    },
    openPage() {
      // let guide = this.$router.resolve({
      //   path: "/guide",
      // });
      window.open("https://hrcloud.ciicpt.com.cn/file/HR_20220525.pdf", "_blank");
    },
  },
};
</script>
<style scoped="scoped">
#main #home {
  background: transparent;
  box-shadow: none;
  padding: 0;
  display: flex;
}

#home > div:nth-of-type(1) {
  flex-grow: 1;
  margin-right: 20px;
}

.leftCon {
  width: 355px;
}

.left-top {
  display: flex;
  background: #fff;
  height: 174px;
  border-radius: 4px;
  box-shadow: 0px 1px 4px 0px rgba(140, 140, 140, 0.26);
  align-items: center;
  justify-content: space-between;
}
@media screen and (min-width: 1920px) {
  .left-top {
    height: 140px;
  }
}

.left-top .item {
  flex-grow: 1;
  position: relative;
  cursor: pointer;
}

.left-top .item:after {
  content: "";
  position: absolute;
  right: 0;
  top: 8px;
  width: 2px;
  height: 68px;
  background: rgba(234, 234, 234, 1);
}

.left-top .item:nth-last-of-type(1):after {
  display: none;
}

.left-top span {
  display: block;
  font-size: 56px;
  line-height: 56px;
  font-weight: 400;
  color: rgba(255, 134, 121, 1);
  text-align: center;
}

.left-top .item:nth-of-type(2) span {
  color: #27ccc3;
}

.left-top .item:nth-of-type(3) span {
  color: #44d38a;
}

.left-top .item:nth-of-type(4) span {
  color: #f06565;
}

.left-top .item:nth-of-type(5) span {
  color: #678fe6;
}

.left-top .item:nth-of-type(6) span {
  color: #e785bc;
}

.left-top p {
  font-size: 20px;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  text-align: center;
  margin-top: 10px;
}
.left-top .f16 {
  font-size: 16px;
}

.img img {
  margin-top: 10px;
  display: block;
  cursor: pointer;
}

.el-link.is-underline:hover:after {
  display: none;
}
.shortMenu >>> .el-link--inner {
  font-size: 13px;
  color: rgba(153, 153, 153, 1);
}
.Mask {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 8;
}
</style>
